import { IRequestModel, HttpMethod, ValidationResponse } from "../../IRequestModel";
import AuthValidation from "../../validation/AuthValidation";

export class ForgottenPasswordRequest implements IRequestModel {

    constructor(user: string) {
        this.user = user;
    }

    uri: string = "auth/forgot-pass";
    method: HttpMethod = HttpMethod.POST;

    user: string;

    isValid(): ValidationResponse {
        return AuthValidation.UserValid(this.user, "Username or Email");
    }
}